import React from 'react';
import PropTypes from 'prop-types';

const Talk = ({ data }) => {
  // Some entries only carry the event, so fall back to it for the heading.
  const heading = data.title || data.event;
  const details = [
    data.title ? data.event : null,
    data.location,
    data.daterange,
  ].filter(Boolean).join(', ');

  return (
    <article className="talk-container">
      <header>
        <h4 className="talk-title">
          {data.link ? <a href={data.link}>{heading}</a> : heading}
        </h4>
        {details ? <p className="talk-event">{details}</p> : null}
        {data.coSpeakers ? <p className="talk-speakers">{data.coSpeakers}</p> : null}
      </header>
    </article>
  );
};

Talk.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    event: PropTypes.string.isRequired,
    location: PropTypes.string,
    daterange: PropTypes.string,
    coSpeakers: PropTypes.string,
    link: PropTypes.string,
  }).isRequired,
};

export default Talk;
